import React from 'react';

const Section = ({ title, children }) => (
  <section className="space-y-2">
    <h2 className="text-lg font-bold text-gray-900">{title}</h2>
    <div className="space-y-2 text-sm leading-7 text-gray-700">{children}</div>
  </section>
);

export const TermsContent = () => (
  <div className="space-y-7">
    <p className="text-sm text-gray-500">시행일: 2026년 9월 19일</p>

    <Section title="제1조 (목적)">
      <p>본 약관은 PreviaWorks(이하 “회사”)가 제공하는 FC퍼널 서비스(이하 “서비스”)의 이용과 관련하여 회사와 이용자 사이의 권리, 의무 및 책임사항을 정하는 것을 목적으로 합니다.</p>
    </Section>

    <Section title="제2조 (서비스의 내용)">
      <p>서비스는 보험설계사 등 영업 종사자를 위한 웹 기반 고객관리 및 영업 퍼널 관리 도구입니다.</p>
      <p>주요 기능에는 고객 정보 관리, 영업 단계 관리, 상담·소통 기록, 일정·알림, 데이터 내보내기·백업 등 서비스 화면에 표시되는 기능이 포함됩니다.</p>
    </Section>

    <Section title="제3조 (체험 및 유료 이용)">
      <p>1. 신규 이용자는 7일 동안 서비스를 무료로 체험할 수 있습니다.</p>
      <p>2. 무료체험 종료 후 계속 이용하려면 월 7,900원의 이용료를 결제해야 합니다.</p>
      <p>3. 실제 결제수단, 결제주기, 갱신 여부 등 구체적인 거래조건은 결제 전에 서비스 화면에서 별도로 안내합니다.</p>
      <p>4. 이용자의 별도 동의 없이 유료 정기결제로 전환하지 않습니다.</p>
    </Section>

    <Section title="제4조 (청약철회 및 환불)">
      <p>1. 유료 서비스의 청약철회 및 환불은 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관계 법령에 따릅니다.</p>
      <p>2. 법령상 청약철회가 제한되는 경우에는 결제 전에 그 제한 사유를 명확히 안내하고 필요한 동의를 받습니다.</p>
      <p>3. 환불이 인정되는 경우 회사는 관계 법령에서 정한 기한과 방법에 따라 환급 절차를 진행합니다.</p>
    </Section>

    <Section title="제5조 (이용자의 의무)">
      <p>이용자는 타인의 정보를 무단으로 이용하거나, 관련 법령에 위반되는 정보를 입력하거나, 서비스의 정상적인 운영을 방해하는 행위를 해서는 안 됩니다.</p>
      <p>이용자가 고객 등 제3자의 개인정보를 서비스에 입력하는 경우, 해당 정보를 적법하게 수집·이용할 책임은 이용자에게 있습니다.</p>
    </Section>

    <Section title="제6조 (이용자 데이터)">
      <p>이용자가 직접 입력하는 고객 데이터는 원칙적으로 이용자의 브라우저 로컬 저장소(IndexedDB 등)에 저장됩니다.</p>
      <p>이용자가 백업·동기화 기능을 직접 사용하는 경우 해당 기능 수행에 필요한 범위에서 외부 서비스로 데이터가 전송될 수 있으며, 구체적인 내용은 개인정보처리방침 및 기능 화면에서 안내합니다.</p>
    </Section>

    <Section title="제7조 (서비스의 변경·중단)">
      <p>회사는 운영상 또는 기술상 필요한 경우 서비스의 전부 또는 일부를 변경하거나 일시 중단할 수 있습니다. 이용자에게 중대한 영향을 미치는 변경은 합리적인 기간 전에 서비스 내 공지 등으로 안내합니다.</p>
    </Section>

    <Section title="제8조 (책임)">
      <p>회사는 관계 법령이 허용하는 범위에서 서비스 장애, 외부 서비스 장애, 이용자의 기기·네트워크 환경 또는 이용자의 귀책사유로 발생한 손해에 대하여 책임을 제한할 수 있습니다.</p>
      <p>다만, 회사의 고의 또는 중대한 과실로 인한 책임까지 배제하지 않습니다.</p>
    </Section>

    <Section title="제9조 (약관의 변경)">
      <p>회사는 관계 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 이용자에게 불리한 중요한 변경은 시행 전에 서비스 내 공지 등 합리적인 방법으로 안내합니다.</p>
    </Section>

    <Section title="제10조 (분쟁 및 준거법)">
      <p>본 약관은 대한민국 법령에 따라 해석됩니다. 서비스 이용과 관련한 분쟁은 당사자 간 협의를 우선하며, 해결되지 않는 경우 관계 법령이 정한 관할법원에 따릅니다.</p>
    </Section>

    <Section title="제11조 (문의)">
      <p>서비스 관련 문의는 FC퍼널 내 카카오톡 문의 또는 PreviaWorks 카카오톡 채널(@previaworks)을 이용할 수 있습니다.</p>
    </Section>
  </div>
);

export const PrivacyContent = () => (
  <div className="space-y-7">
    <p className="text-sm text-gray-500">시행일: 2026년 9월 19일</p>

    <Section title="1. 개인정보의 처리 목적">
      <p>PreviaWorks(이하 “회사”)는 FC퍼널의 무료체험 관리, 유료 서비스 제공, 이용 승인·상태 관리, 문의 대응, 서비스 안정성 및 이용현황 분석, 알림 제공을 위해 필요한 개인정보를 처리합니다.</p>
    </Section>

    <Section title="2. 처리하는 개인정보 항목">
      <p>서비스 이용·승인 과정에서 이용자 이름, 연락처, 이메일(선택), 회사명, 직책, 기기 식별자(deviceId), 체험 시작일, 서비스 상태, 브라우저·기기 정보(User Agent), 유입경로, 접속·이용 기록이 처리될 수 있습니다. 접속 IP는 호스팅 제공자의 운영 로그에 기록될 수 있습니다.</p>
      <p>푸시 알림을 사용하는 경우 푸시 토큰이 처리될 수 있습니다.</p>
      <p>이용자가 입력하는 고객 이름, 연락처, 생년월일, 메모, 상담·소통 이력 등 고객 데이터는 원칙적으로 이용자의 브라우저 로컬 저장소(IndexedDB 등)에 저장됩니다.</p>
      <p>운영을 위한 기기 상태, 신청 정보, 이용 통계, 방문·행동 로그, 푸시 토큰과 알림 설정은 Firebase에 저장됩니다. 기존에 생성된 행동 로그에는 고객명이 포함되었을 수 있으며, 신규 로그에서는 고객명을 전송하지 않습니다.</p>
    </Section>

    <Section title="3. 개인정보의 처리 및 보유기간">
      <p>회사는 개인정보를 처리 목적 달성 시까지 또는 이용자의 삭제 요청 시까지 보유하며, 관계 법령에 따라 보존할 의무가 있는 경우 해당 기간 동안 별도로 보관합니다.</p>
      <p>전자상거래 관련 법령에 따라 계약 또는 청약철회, 대금결제 및 재화·서비스 공급에 관한 기록은 법정 보존기간 동안 보관될 수 있습니다.</p>
    </Section>

    <Section title="4. 개인정보의 제3자 제공">
      <p>회사는 원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 다만, 정보주체의 동의를 받거나 법률에 특별한 규정이 있는 경우 등 관계 법령이 허용하는 범위에서는 예외로 합니다.</p>
    </Section>

    <Section title="5. 개인정보 처리업무의 위탁">
      <p>회사는 서비스 운영을 위해 Google/Firebase 등 클라우드 인프라를 이용할 수 있습니다. 이 경우 기기 상태, 푸시 토큰, 서비스 운영 로그 등 서비스 제공에 필요한 정보가 처리될 수 있습니다.</p>
      <p>이용자가 Google Drive 백업 기능을 직접 사용하는 경우, 백업 데이터는 이용자가 연결한 Google 계정의 저장공간으로 전송될 수 있습니다.</p>
      <p>지도·주소 검색 기능 사용 시 입력한 주소가 지도·지오코딩 제공자에게 전송될 수 있습니다. Google Calendar 연결 시 일정 관련 정보가 Google API와 연동되고, 승인 요청 알림에는 신청 정보가 이메일 발송 서비스(Resend)를 통해 전송됩니다. 이용 통계에는 Google Analytics가 사용됩니다.</p>
    </Section>

    <Section title="6. 개인정보의 파기">
      <p>보유기간이 지나거나 처리 목적이 달성되어 개인정보가 불필요해지면 지체 없이 파기합니다. 전자적 파일은 복구가 어렵도록 삭제하고, 출력물 등 종이 형태의 자료가 있는 경우 분쇄 또는 이에 준하는 방법으로 파기합니다.</p>
    </Section>

    <Section title="7. 정보주체의 권리와 행사방법">
      <p>정보주체는 자신의 개인정보에 대해 열람, 정정·삭제, 처리정지 및 동의 철회 등 관계 법령에서 보장하는 권리를 행사할 수 있습니다.</p>
      <p>권리 행사는 FC퍼널 내 문의 기능 또는 PreviaWorks 카카오톡 채널(@previaworks)을 통해 요청할 수 있으며, 회사는 관계 법령에 따라 처리합니다.</p>
    </Section>

    <Section title="8. 개인정보의 안전성 확보조치">
      <p>회사는 개인정보의 분실, 도난, 유출, 위조·변조 또는 훼손을 방지하기 위하여 접근권한 관리, 접근통제, 전송구간 보호 등 서비스 규모와 처리내용에 맞는 기술적·관리적 보호조치를 적용합니다.</p>
    </Section>

    <Section title="9. 자동수집 정보">
      <p>서비스 이용 과정에서 기기·브라우저 정보, 접속 시각, 이용기록 등이 생성·수집될 수 있습니다. 브라우저에서 외부 IP 확인 서비스(api.ipify.org)를 호출하는 신규 수집은 중단했습니다. 호스팅 제공자의 접속 로그에는 IP가 남을 수 있습니다.</p>
    </Section>

    <Section title="10. 개인정보 보호책임자 및 문의">
      <p>개인정보 보호책임자: 최태욱</p>
      <p>문의: PreviaWorks 카카오톡 채널(@previaworks)</p>
    </Section>

    <Section title="11. 권익침해 구제">
      <p>개인정보 침해와 관련한 상담이나 신고가 필요한 경우 개인정보침해 신고센터, 개인정보분쟁조정위원회 등 관계 기관을 이용할 수 있습니다.</p>
    </Section>

    <Section title="12. 개인정보처리방침의 변경">
      <p>본 방침의 내용이 변경되는 경우 시행 전에 서비스 내 공지 또는 이에 준하는 방법으로 안내합니다.</p>
    </Section>
  </div>
);
